import type { HubView } from "@/components/hub/use-hub-store";
import type { AvailableActivity } from "@/lib/api/activities";
import type { ActionSuggestionDescriptor } from "./context/action-suggestion";
import {
  contentToolForSuggestionAction,
  type ContentToolId,
} from "./tools/tool-config";

export interface LaunchSuggestionActionDeps {
  suggestion: ActionSuggestionDescriptor;
  openContentCreate: (id: ContentToolId) => void;
  selectActivity: (activity: AvailableActivity) => void;
  activities: AvailableActivity[];
  openHubEntity: (view: HubView, entityId: string) => void;
}

export function launchSuggestionAction({
  suggestion,
  openContentCreate,
  selectActivity,
  activities,
  openHubEntity,
}: LaunchSuggestionActionDeps): boolean {
  const action = suggestion.primaryAction;
  if (!action) return false;

  switch (action.id) {
    case "open_activity":
    case "open_hub": {
      openHubEntity(action.targetEntity.view, action.targetEntity.id);
      return true;
    }
    case "share_moment":
    case "start_swap": {
      const contentTool = contentToolForSuggestionAction(action.id);
      if (!contentTool) return false;
      openContentCreate(contentTool.id);
      return true;
    }
    case "hot_takes":
    case "connect_moment":
    case "deep_thoughts": {
      const activity = activities.find((item) => item.type === action.id);
      if (!activity) return false;
      selectActivity(activity);
      return true;
    }
    default: {
      const _exhaustive: never = action;
      return _exhaustive;
    }
  }
}
